import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material/material.module';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

const MODULES = [
  MaterialModule,
  LoadingBarModule,
  InfiniteScrollModule
];

@NgModule({
  imports: [CommonModule, ...MODULES],
  exports: MODULES,
})
export class SharedThirdPartyModule {}
